module.exports = __webpack_public_path__ + "img/zm_fehuo@3x.6b571c32.png";